<template>
    <div class="sp-booking-info">
        <div class="sp-booking-title sp-booking-item" v-if="specialBooking.specialBookingType==1" @click="showRulePopup(specialBooking.image)">
            <img class="item-icon" src="https://resource.rcclchina.com.cn/wechatMiniProgram/WechatMiniProgramImage/birthdayRoom/birthday_icon.png" />
            <span>{{stateroomName}}：享受收费生日礼遇</span>
            <img class="item-click" src="https://resource.rcclchina.com.cn/tui2/info/webhao.png">
        </div>
        <div class="sp-booking-select sp-booking-item" @click="showSelector">
            <div class="sp-guests" v-if="selectedGuests.length==0">暂不选择</div>
            <div class="sp-guests sp-guests-select" v-else>修改/取消生日礼遇</div>
            <img src="https://resource.rcclchina.com.cn/tui2/list/icon-down.png"/>
        </div>
        <div class="sp-booking-guests" v-if="selectedGuests.length>0">
            <div>已选择<span>{{selectedGuestName}}</span>享受生日礼遇</div>
            <div>
                将于<span>{{selectedDate}} 晚餐 {{selectedPlace}}</span>享用生日蛋糕
            </div>
        </div>
        <div class="item-discounts">
          <span class="discounts-right">限时优惠：</span>{{ specialBooking.price || 0 }}元/人(建议价<span class="discounts-left">800元</span>)；
        </div>
        <guest-info-special-booking-select 
            v-if="isShowSelect"
            :isShow="isShowSelect"
            :specialBooking="specialBooking"
            :mealInfoViews="mealInfoViews"
            :guests="guests"
            :couponCode="couponCode"
            :sessionToken="sessionToken"
            :onClose="closeSelector"
        />

        <suite-stateroom-popup 
            :isShow="isShowRulePopup"
            :suiteImage="targetRuleImage"
            v-on:onModalClose="closeRulePopup"
        />
    </div>
</template>

<script>
import { numberToChinese } from '@/utilities/tools'
const SuiteStateroomPopup = () =>  import('@/components/Cruise/CruiseDetail/SuiteStateroomPopup.vue')
const GuestInfoSpecialBookingSelect = () => import('@/components/Booking/GuestInfo/GuestInfoSpecialBookingSelect')

export default {
    name: "GuestInfoSpecialBooking",
    components: {
        GuestInfoSpecialBookingSelect,
        SuiteStateroomPopup
    },
    props: {
        specialBookingInfo: {
            type: Object,
            default () {
                return {}
            }
        },
        booking: {
            type : Object,
            default () {
                return {}
            }
        },
        stateroomIndex: {
            type: Number
        }
    },
    data () {
        return {
            isShowSelect: false,
            isShowRulePopup: false,
            targetRuleImage: ""
        }
    },
    methods: {
        closeSelector () {
            this.isShowSelect = false
        },
        showSelector () {
            let completedGuests = this.guests.filter(r=>r.pyLastName && r.pyLastName.length > 0
             && r.pyFirstName && r.pyFirstName.length > 0
             && r.birthDate && r.birthDate.length > 0)
            if (completedGuests.length < 1) {
                this.$alert.show('请先添加乘客信息！')
            } else {
                this.isShowSelect = true
            }
        },
        showRulePopup (ruleImage) {
            this.targetRuleImage = ruleImage
            this.isShowRulePopup = true
        },
        closeRulePopup () {
            this.isShowRulePopup = false
        }
    },
    computed: {
        guests() {
            if (this.booking.guests && this.booking.guests.guestPersons) {
                return this.booking.guests.guestPersons
            }
            return []
        },
        sessionToken () {
            return this.booking.sessionToken
        },
        couponCode () {
            return this.booking.couponCode
        },
        specialBookings () {
            return this.specialBookingInfo.specialBookingViewModels || []
        },
        specialBooking () {
            return this.specialBookings.length == 0 ? {}: this.specialBookings[0]
        },
        mealInfoViews () {
            return this.specialBookingInfo.mealInfoViews || []
        },
        selectedGuests () {
            return this.guests
                .filter(r=>r.specialBookingOrder 
                && r.specialBookingOrder.specialBookingType == this.specialBooking.specialBookingType)
        },
        selectedGuestName () {
            let names = []
            this.selectedGuests.forEach(guest=> {
                let name = guest.lastName + guest.firstName
                if (!name || name.trim().length == 0) {
                    name = `${guest.pyLastName} ${guest.pyFirstName}`
                }
                names.push(name)
            })
            return names.join('、')
        },
        selectedDate () {
            if (this.selectedGuests.length > 0) {
                return this.selectedGuests[0].specialBookingOrder.specialBookingDate
            }
            return ""
        },
        selectedTimeslot () {
            let timeslot = 0
            if (this.selectedGuests.length > 0) {
                timeslot = this.selectedGuests[0].specialBookingOrder.specialBookingTimeslot
                let mealInfo = this.mealInfoViews.find(r=>r.mealTimeType == timeslot)
                return mealInfo ? mealInfo.mealTime : ""
            }
            return ""
        },
        selectedPlace () {
            let place = 0
            if (this.selectedGuests.length > 0) {
                place = this.selectedGuests[0].specialBookingOrder.specialBookingPlace
                let mealInfo = this.mealInfoViews.find(r=>r.mealPlaceType == place)
                return mealInfo ? mealInfo.mealPlace : ""
            }
            return ""
        },
        stateroomName () {
            return `客房${numberToChinese(this.stateroomIndex+1)}`
        }
    }
}
</script>

<style lang="less" scoped>
.sp-booking-info {
    margin: 23px 0 0 23px;
    width: 704px;
    padding: 18px 29px 13px;
    border: 1px solid #fbbb00;
    border-radius: 8px;
    position: relative;
    .sp-booking-item {
        display: inline-block;
        vertical-align: middle;
        &.sp-booking-title {
            cursor: pointer;
            .item-icon {
                width: 28px;
                margin-right: 10px;
            }
            span {
                font-size: 14px;
                color: #282b2c;
                font-weight: 600;
            }
            .item-click {
                width: 15px;
                margin-left: 10px;
            }
        }
        &.sp-booking-select {
            float: right;
            position: relative;
            top: 3px;
            cursor: pointer;
            .sp-guests {
                display: inline-block;
                font-size: 14px;
                color: #919b9f;
                font-weight: 600;
                margin-right: 10px;
            }
            img {
                width: 15px;
            }
        }
    }

    .sp-booking-guests {
        margin-top: 10px;
        margin-left: 38px;
        font-size: 14px;
        color: #747d80;
        font-weight: 600;
        letter-spacing: 1px;
        span {
            color: #282b2c;
            text-decoration: underline;
            margin: 0px 8px;
        }
    }
    .item-discounts{
      height: 34px;
      width: 100%;
      margin: 14px 0 0;
      background: #f8e2db;
      font-size: 14px;
      padding-left: 15px;
      line-height: 34px;
      color: #282b2c;
      .discounts-right{
        color: #e04d2a;
        font-weight: bold;
      }
      .discounts-left{
        text-decoration: line-through;
      }
    }
}
</style>